export const homePath = (trigger = '') => `/${trigger ? '?trigger=' + trigger : ''}`;
export const logoHomePath = () => '/home';
